import { render } from "./ProgramaCurva.vue?vue&type=template&id=721965c6&scoped=true"
import script from "./ProgramaCurva.vue?vue&type=script&lang=js"
export * from "./ProgramaCurva.vue?vue&type=script&lang=js"

import "./ProgramaCurva.vue?vue&type=style&index=0&id=721965c6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-721965c6"]])

export default __exports__